<template>
    <div>
        <el-form
            v-loading="loading"
            ref="form"
            :model="model"
            :modelOrigin="modelOrigin"
            label-width="242px"
            label-position="left"
        >
            <el-tabs v-model="activeTab">
                <el-tab-pane
                    :key="tab.label"
                    v-for="tab in config.formFields"
                    :label="tab.label"
                >
                    <div
                        :model="model"
                        :modelOrigin="modelOrigin"
                        :settings="settings"
                        :root-config="rootConfig"
                        :api="api"
                        @updated="assignSettings"
                        :is="item.component"
                        :options="item.options"
                        v-for="item in tab.body"
                        :key="item._uid"
                    ></div>

                    <el-form-item
                        :key="field.name"
                        :label="field.label"
                        v-for="field in tab.fields"
                    >
                        <div
                            :placeholder="field.placeholder"
                            :root-config="rootConfig"
                            :options="field.options"
                            :type="field.type"
                            :is="field.component"
                            :root-model="model"
                            v-if="model[field.name.split('.')[0]]"
                            v-model="
                                model[field.name.split('.')[0]][
                                    field.name.split('.')[1]
                                ]
                            "
                        ></div>
                    </el-form-item>
                </el-tab-pane>
            </el-tabs>

            <el-form-item v-if="!hideSave">
                <el-button type="primary" @click="onSubmit">Save</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import convertSettings from '../libs/settings';

export default {
    props: ['config', 'rootConfig'],

    data() {
        return {
            activeTab: '0',
            api: null,
            loading: true,
            model: {},
            settingValues: {},
            settings: [],
            modelOrigin: {},
        };
    },

    computed: {
        hideSave() {
            return this.config.formFields[this.activeTab].hideSave;
        },
    },

    created() {
        this.api = this.$resource(
            this.rootConfig.endPoint + '/bulk_settings/{id}',
            {},
            {},
            { headers: this.rootConfig.headers }
        );

        this.api.get({ id: 'mine' }).then((res) => {
            this.loading = false;
            this.assignSettings(res.data);
        });
    },

    methods: {
        assignSettings(resData) {
            this.settings = resData;
            this.model = Object.assign({}, convertSettings(resData));
            this.modelOrigin = resData
                .filter((data) => typeof data.origin_id == 'number')
                .sort((a, b) => a.origin_id - b.origin_id);
        },

        onSubmit() {
            this.api.update({ id: 'mine' }, this.model).then((res) => {
                this.$message('Updated successfully');
            });
        },
    },
};
</script>

<style>
h2 {
    margin-bottom: 10px;
}

.setting__live {
    margin-top: 20px;
    margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// Settings.vue?4e82cc3c